module.exports = __webpack_public_path__ + "static/downtown-footer-d3650b98e77cb623390f1c693e8ca24c.png";